import React from "react";
import { Icon } from "@components/Icons";
import Text from "./Text";
import ButtonGroup from "./ButtonGroup";
import { colors } from "@utils/styles";

export default function CallToActionBtn(props) {
	return (
		<ButtonGroup
			button1Variant={props.variant}
			buttonWidth={{ xs: 12 }}
			additionalClasses="min-height-auto"
			btn1={{
				url: props.link,
				text: <Icon icon={props.icon} style={props.iconStyle} color={props.iconColor} />,
			}}
			button1Children={<Text marginBottom="0" text={props.text} size={"13px"} color={colors["white"]} />}
		/>

		// <Button variant={props.variant}>
		// 	<DynamicLink classes={"align-items-center d-flex"} href={props.link}>
		// 		{props.icon && <Icon icon={props.icon} style={props.iconStyle} color={props.iconColor} />}
		// 		<Text marginBottom="0" text={props.text} size={"13px"} color={colors["white"]} />
		// 	</DynamicLink>
		// </Button>
	);
}
